<ng-container *ngIf="!isHorseRace; else horseTemplate"
    ><span>{{ title }}</span
    ><span class="winmarket-title">{{ distance }}</span></ng-container
><ng-template #horseTemplate
    ><span *ngIf="title">{{ title }}</span
    ><span class="winmarket-title" *ngIf="distance">, {{ distance }}</span>
</ng-template>
